var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.64062V6.375C24 4.92525 22.8248 3.75 21.375 3.75H2.625C1.17525 3.75 0 4.92525 0 6.375V7.64062C0 7.70279 0.024693 7.7624 0.0686468 7.80635C0.112601 7.85031 0.172215 7.875 0.234375 7.875H23.7656C23.8278 7.875 23.8874 7.85031 23.9314 7.80635C23.9753 7.7624 24 7.70279 24 7.64062ZM0 9.60938V17.625C0 19.0747 1.17525 20.25 2.625 20.25H21.375C22.8248 20.25 24 19.0747 24 17.625V9.60938C24 9.54721 23.9753 9.4876 23.9314 9.44365C23.8874 9.39969 23.8278 9.375 23.7656 9.375H0.234375C0.172215 9.375 0.112601 9.39969 0.0686468 9.44365C0.024693 9.4876 0 9.54721 0 9.60938ZM6 15.75C6 16.1642 5.66419 16.5 5.25 16.5H4.5C4.08581 16.5 3.75 16.1642 3.75 15.75V15C3.75 14.5858 4.08581 14.25 4.5 14.25H5.25C5.66419 14.25 6 14.5858 6 15V15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDark);
export default __webpack_public_path__ + "static/media/PaymentDark.c2f460414a463260b0c14d2ab4a6580d.svg";
export { ForwardRef as ReactComponent };